import { BlitzPage } from "@blitzjs/next"
import { useMutation } from "@blitzjs/rpc"
import React, { Suspense, useState } from "react"
import Loading from "app/core/components/Loading"
import { generatePrivateSchoolLayout } from "app/core/layouts/BookingLayout"
import style from "app/bookings/bookings.module.css"
import { z } from "zod"
import { Form } from "app/core/components/Form"
import LabeledTextField from "app/core/components/LabeledTextField"
import LabeledCheckboxField from "app/core/components/LabeledCheckboxField"
import Spinner from "react-md-spinner"
import { Button } from "app/core/components/Button"
import { RequestPrivateSchoolBooking } from "app/bookings/validations"
import submitPrivateSchoolBooking from "app/bookings/mutations/submitPrivateSchoolBooking"
const PrivateSchoolForm = () => {
  const [submitPrivateSchoolBookingMutation] = useMutation(submitPrivateSchoolBooking)
  const [submitted, setSubmitted] = useState(false)
  return (
    <Form
      schema={RequestPrivateSchoolBooking}
      onSubmit={async (values) => {
        await submitPrivateSchoolBookingMutation(values)
        setSubmitted(true)
      }}
    >
      {(form) => {
        return (
          <>
            <div className="grid max-w-xl grid-cols-2 mx-auto sm:grid-cols-4 gap-x-8 gap-y-6">
              <LabeledTextField
                name="schoolName"
                label="School Name"
                outerProps={{ className: "col-span-2" }}
              />
              <LabeledTextField
                name="contactName"
                label="Contact name"
                outerProps={{ className: "col-span-2" }}
              />
              <LabeledTextField
                name="contactTitle"
                label="Title"
                outerProps={{ className: "col-span-2" }}
              />
              <LabeledTextField
                name="contactEmail"
                label="Email"
                outerProps={{ className: "col-span-2" }}
              />
              <LabeledTextField
                name="contactPhone"
                label="Phone Number"
                outerProps={{ className: "col-span-2" }}
              />
              <LabeledTextField
                name="studentsTesting"
                label="# of Students Testing"
                outerProps={{ className: "col-span-2" }}
              />
              <div className="col-span-4">
                <div># of Students by Grade Levels</div>
                <div className="grid grid-cols-3 gap-x-4 gap-y-2">
                  <LabeledTextField name="numOfGradeKStudents" label="Grade K" type="number" />
                  <LabeledTextField name="numOfGrade1Students" label="Grade 1" type="number" />
                  <LabeledTextField name="numOfGrade2Students" label="Grade 2" type="number" />
                  <LabeledTextField name="numOfGrade3Students" label="Grade 3" type="number" />
                  <LabeledTextField name="numOfGrade4Students" label="Grade 4" type="number" />
                  <LabeledTextField name="numOfGrade5Students" label="Grade 5" type="number" />
                  <LabeledTextField name="numOfGrade6Students" label="Grade 6" type="number" />
                  <LabeledTextField name="numOfGrade7Students" label="Grade 7" type="number" />
                  <LabeledTextField name="numOfGrade8Students" label="Grade 8" type="number" />
                  <LabeledTextField name="numOfGrade9Students" label="Grade 9" type="number" />
                  <LabeledTextField name="numOfGrade10Students" label="Grade 10" type="number" />
                  <LabeledTextField name="numOfGrade11Students" label="Grade 11" type="number" />
                  <LabeledTextField name="numOfGrade12Students" label="Grade 12" type="number" />
                </div>
              </div>

              <div className="col-span-2">
                <div>Seasons</div>
                <div className="grid grid-cols-2 gap-x-12 gap-y-2">
                  <LabeledCheckboxField name="fall" label="Fall" />
                  <LabeledCheckboxField name="winter" label="Winter" />
                  <LabeledCheckboxField name="spring" label="Spring" />
                </div>
              </div>

              <div className="col-span-2">
                <div>Subjects Required</div>
                <div className="grid grid-cols-2 gap-x-12 gap-y-2">
                  <LabeledCheckboxField name="reading" label="Reading" />
                  <LabeledCheckboxField name="math" label="Math" />
                  <LabeledCheckboxField name="language" label="Language Usage" />
                  <LabeledCheckboxField name="science" label="Sciences 3-12" />
                </div>
              </div>

              <div className="col-span-4">
                <LabeledTextField
                  name="otherQuestions"
                  label="Approximate testing date and any other questions"
                  outerProps={{ className: "col-span-2" }}
                />
              </div>

              <Button disabled={form.invalid || submitted} className="w-full md:w-auto">
                {form.submitting ? <Spinner size={26} singleColor="#ffffff" /> : <>Submit</>}
              </Button>
            </div>
            {submitted && (
              <div className="grid max-w-xl mx-auto">
                Expect to hear from us within 2 business days. If you have any questions or need
                quicker turnaround, please feel free to call us at 844-746-2677 or email
                sales@homeschoolboss.com
              </div>
            )}
          </>
        )
      }}
    </Form>
  )
}
const PrivateSchoolPage: BlitzPage = () => {
  return (
    <div className={style["bookings-container"]}>
      <Suspense fallback={<Loading />}>
        <PrivateSchoolForm />
      </Suspense>
    </div>
  )
}

// PrivateSchoolPage.authenticate = true
PrivateSchoolPage.getLayout = generatePrivateSchoolLayout({ title: "Private School Booking" })
export default PrivateSchoolPage
